import { useApiContext } from '../components/App/AppApi'
import { ConfigModel, MainLayoutParamsModel, ReportModel, ReportSummaryModel, TokenModel } from '../defs/defs'
import eqxApi, { eqxApiProps } from '../shared/classes/eqxApi'
import eqxEndpoint from '../shared/classes/eqxEndpoint'

export function useApi(api: appApi | null = null) {
    const apiContext = useApiContext()
    if (api) return api
    return apiContext
}

interface StandardError {
    status?: string
    message: string
}
interface StandardSuccess {
    message: string
}
interface StandardSuccessWithData<T> {
    message: string
    data: T
}
interface TokenParams {
    aadToken: string
    version: string
}
interface ConfigParams {

}
interface TenantByIdResponse {
    name: string
    resourceIdentifier: string
    displayID: string
}

/** BI module routes on the v2 API today; shared endpoints will omit this segment later. */
export const BI_API = '/continuum-bi'

/**
 * here we can place any mofifications to the default behaviour of the standard app
 */
class appApi extends eqxApi {
    constructor(props: eqxApiProps) {
        super(props)
    }

    endpoints = {
        //auth
        token: () => new eqxEndpoint<TokenModel, TokenParams>(`${BI_API}/token`, 'post'),
        config: () => new eqxEndpoint<ConfigModel, ConfigParams>(`${BI_API}/config`, 'post'),
        tenantById: (id: string) =>
            new eqxEndpoint<TenantByIdResponse>(`${BI_API}/config/tenants/${encodeURIComponent(id)}`, 'get'),

        //global
        mainLayoutParams: () => new eqxEndpoint<MainLayoutParamsModel>(`${BI_API}/main-layout`, 'get'),
        sendHelpEmail: () => new eqxEndpoint<StandardSuccess, FormData>(`${BI_API}/send-help-email`, 'post'),

        //global
        reports: () => new eqxEndpoint<ReportSummaryModel[]>(`${BI_API}/reports`, 'get'),
        report: (id: string) => new eqxEndpoint<ReportModel>(`${BI_API}/reports/${id}`, 'get'),
    }
}
export { appApi as default, type ConfigParams, type TenantByIdResponse, type TokenParams }
